import { UserIcon } from "vega-icons";

import { useUserProfile } from "@vega-api/extended/auth/hooks";
import { InteractiveButton } from "@vega-core/components/Buttons/InteractiveButton";
import { SectionHeader } from "@vega-core/components/Layout/SectionHeader";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { EmailContactModal } from "@vega-core/components/Modals/EmailContactModal/EmailContactModal";
import { Notice } from "@vega-core/components/Notice/Notice";
import { useBoolean } from "@vega-core/hooks/useBoolean";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";
import { isFalsy } from "@vega-core/utils/isFalsy";

import { DetailRow } from "../components/DetailRow";
import { SettingsSectionLayout } from "../components/SettingsSectionLayout";

export function Profile() {
  const { data: profile, isLoading: isUserProfileLoading } = useUserProfile();
  const isContactModalOpen = useBoolean(false);
  const {
    contacts: { helpEmail = "" },
  } = usePublicConfig();

  if (isUserProfileLoading || isFalsy(profile)) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <SettingsSectionLayout bordered>
        <div className="flex flex-col gap-4">
          <Notice
            content={
              <div>
                {m.settings_profileNotice()}{" "}
                <InteractiveButton
                  dataTestId="contact-us-button"
                  onClick={isContactModalOpen.setTrue}
                  variant="text"
                >
                  {m.titles_contactUs()}
                </InteractiveButton>
              </div>
            }
          />
          <SectionHeader
            icon={<UserIcon />}
            showIconBackground={false}
            title={m.settings_basicInfo()}
          />
          <div className="flex flex-col gap-4 w-full">
            <DetailRow
              label={m.settings_firstName()}
              value={profile.firstName || "-"}
            />
            <DetailRow
              label={m.settings_lastName()}
              value={profile.lastName || "-"}
            />
            <DetailRow
              label={m.settings_email()}
              value={profile.email || "-"}
            />
            <DetailRow
              label={m.settings_phone()}
              value={profile.phone || "-"}
            />
          </div>
        </div>
      </SettingsSectionLayout>
      <EmailContactModal
        email={helpEmail}
        onClose={isContactModalOpen.setFalse}
        open={isContactModalOpen.value}
      />
    </>
  );
}
